

import useTipoBiografiaStore from '@/store/TipoBiografia';
import useConfiguracionStore from "@/store/configuracion";
import useUsuarioStore from '@/store/usuario';
import useInvitacionStore from '@/store/invitacion';
import useEntrevistaStore from '@/store/entrevista';
import useBiografiaStore from '@/store/biografia';
import usePapelStore from '@/store/papel';



export default function useConfiguracion(is_public = false){

  const router = useRouter();
  // Stores
  const store_tipo_biografia = useTipoBiografiaStore();
  const configuracion_store  = useConfiguracionStore();
  const papel_store          = usePapelStore();
  const invitacion_store     = useInvitacionStore();
  const bio_store = useBiografiaStore();
  const usuario_store = useUsuarioStore();
  const colaboradores  = ref([]);
  const showFormColaborador = ref(false);
  const showFormPortada = ref(false);


  const { biografia } = storeToRefs(bio_store);
  const { fetchSelectList: fetch_papels } = papel_store;
  const { fetchSelectList: fetch_tb } = store_tipo_biografia;
  const { configuracion, optionsTono, optionsNarracion, optionsExtension } =
    storeToRefs(configuracion_store);

  const initialValues = configuracion;

  const { usuario } = storeToRefs(usuario_store);
  const { guardar } = configuracion_store;


  const showConfiguracion = ref(false);
  const showAyuda = ref(false);
  const tipos_biografias = ref([]);
  const papels = ref([]);

   const configuracion_id = computed(() => {
    if (biografia.value && biografia.value.biografiable && biografia.value.biografiable.id) {
      return biografia.value.biografiable.id;
    }
    return null;
   });

  // methods
  const cargarLists = () => {
    fetch_tb().then((data) => {
      tipos_biografias.value = data;
    });

    fetch_papels().then((data) => {
      papels.value = data;
    });
  };

  const cargarColaboradores = () => {
    usuario_store.fetchColaboradores()
    .then((amigos) => {
      colaboradores.value = amigos;
    });

  }

  const agregarColaborador = () => {
    showFormColaborador.value = true;
  }

  const agregarPortada = (config_id) => {
    router.push({name:'configurar.portada',params:{configId:config_id}})
    // showFormPortada.value = true;
  }

  const montarEcho = () => {
    Echo.leave(`usuario.${usuario.value.id}`);

    Echo.private(`usuario.${usuario.value.id}`)
    .listen('.invitacion.enviada', ({invitacion:inv} ) => {
      colaboradores.value.push(inv);
    })
  }

  const actualizarValores = (next) => {
    next(initialValues.value);
  }

  onUnmounted(() => {
    Echo.leave(`usuario.${usuario.value.id}`);
  });

  
  onMounted(() => {
    if(!is_public){
      montarEcho();
      cargarColaboradores();
      cargarLists();
    }else{
      // montarEcho(); no se monta echo en la vista publica
      // cargarColaboradores(); no se cargan colaboradores en la vista publica
      cargarLists();

    }
  })
  
  return {
    configuracion_id,
    colaboradores,
    showFormColaborador,
    showFormPortada,
    showConfiguracion,
    showAyuda,
    tipos_biografias,
    papels,
    biografia,
    initialValues,
    usuario,
    guardar,
    optionsTono,
    optionsNarracion,
    optionsExtension,
    cargarLists,
    agregarColaborador,
    agregarPortada,
    actualizarValores
  };

}